'use client';

import type { FeatureFlags } from '@repo/wemod-api/features/schema';
import { createContext, type ReactNode, useContext } from 'react';

const FeatureFlagsContext = createContext<FeatureFlags | null>(null);

interface FeatureFlagsProviderProps {
    initialFlags: FeatureFlags;
    children: ReactNode;
}

export function FeatureFlagsProvider({ initialFlags, children }: FeatureFlagsProviderProps) {
    return <FeatureFlagsContext.Provider value={initialFlags}>{children}</FeatureFlagsContext.Provider>;
}

export function useFeatureFlags(): FeatureFlags {
    const context = useContext(FeatureFlagsContext);
    if (!context) {
        throw new Error('useFeatureFlags must be used within FeatureFlagsProvider');
    }
    return context;
}

export function useFeatureFlag<K extends keyof FeatureFlags>(key: K): FeatureFlags[K] | undefined {
    return useFeatureFlags()[key];
}
